module.exports = __webpack_public_path__ + "media/application/images/ui/join-page-image-af78e22efb6355681ac6da19f73129ba.png";